import { shopifyPublicationIdFormat } from "@redotech/redo-marketplace-id";
import { ShopifyCatalogStatusSchema } from "@redotech/redo-model/inventory/shopify-listing/shopify-publication";
import * as z from "zod";

const ShopifyPublicationSchema_ = z.object({
  id: shopifyPublicationIdFormat.schema,
  shopifyPublicationId: z.string(),
  shopifyCatalogId: z.string().nullable(),
  title: z.string(),
  status: ShopifyCatalogStatusSchema,
});
export const ShopifyPublicationSchema: z.ZodType<ShopifyPublication> =
  ShopifyPublicationSchema_;
export interface ShopifyPublication extends z.infer<
  typeof ShopifyPublicationSchema_
> {}

export const getShopifyPublications = {
  name: "getShopifyPublications" as const,
  input: z.object({}),
  output: z.object({ publications: z.array(ShopifyPublicationSchema) }),
};
